/* eslint-disable no-undef */
import hasOpenTokSupportHelpers from '../helpers/hasOpenTokSupport';
import env from './env';

const isCryptoSupported = !!window.crypto;

// RTCRtpScriptTransform exists on firefox but we don't support it yet
const isRTCScriptTransformSupported = !!window.RTCRtpScriptTransform && !env.isFirefox;

const isInsertableStreamsSupported = !!window.RTCRtpSender?.prototype.createEncodedStreams
|| !!window.RTCRtpSender?.prototype.createdEncodedVideoStreams || isRTCScriptTransformSupported;

const isWebWorkerSupported = !!window.Worker;

const isE2eeSupported = () =>
  isCryptoSupported && isInsertableStreamsSupported && isWebWorkerSupported;

export default (deps = {}) => {
  /* eslint-disable-next-line global-require */
  const hasOpenTokSupport = deps.hasOpenTokSupport || hasOpenTokSupportHelpers.once;
  const hasE2eeCapability = deps.isE2eeSupported || isE2eeSupported;

  return hasOpenTokSupport() && hasE2eeCapability();
};
